import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import { AuthorNames } from "~/components/article/article-author-block/author-names";
import { AuthorLocation } from "~/components/article/article-author-block/author-names/styles";
import { AuthorAvatar } from "~/components/author/author-avatar";
import { StyledEntityLink as AuthorName } from "~/components/author/author-name/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const StyledAuthorNames = styled(AuthorNames)`
  margin-block-end: 20px;

  color: #333333;
  font-size: 14px;
  line-height: 16px;

  ${AuthorName} {
    text-decoration: underline;
  }

  ${AuthorLocation} {
    color: #333333;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }
`;

export const ArticleDateContainer = styled.div``;

export const AvatarContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  margin-block-end: 8px;
`;

type AuthorAvatarProps = {
  $zIndex: number;
};
export const StyledAuthorAvatar = styled(AuthorAvatar, {
  ...transientOptions,
})<AuthorAvatarProps>``;
